import React, { useState } from 'react';
import './PublicSignUp.css';

export default function MasonPartnership() {
  const [formData, setFormData] = useState({
    currentCustomer: '',
    storeName: '',
    storeAddress: '',
    storeCity: '',
    storeState: '',
    storeZip: '',
    storeEmail: '',
    storePhone: '',
    cityPopulation: '',
    contactName: '',
    contactPhone: '',
    message: ''
  });

const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const payload = {
      ...formData,
      dateSubmitted: new Date().toISOString(),
    };

    try {
      const response = await fetch("https://rgs-a.azurewebsites.net/api/Partnership_Store_Inquiry?code=TCfv400vr9hy8FO_7Y82uxfhO8oYjiK1bdm3bdLEBm1BAzFuDCIv8g==", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        alert("Thanks for submitting! We'll be in touch soon.");
        setFormData({
          currentCustomer: '',
          storeName: '',
          storeAddress: '',
          storeCity: '',
          storeState: '',
          storeZip: '',
          storeEmail: '',
          storePhone: '',
          cityPopulation: '',
          contactName: '',
          contactPhone: '',
          contactEmail: '',
          message: ''
        });
      } else {
        alert("Error submitting form.");
      }
    } catch (error) {
    console.error("❌ Error submitting form:", error);
    // Optionally show error message
  } finally {
    setIsSubmitting(false);
  }
};

  const allowedStates = [
    "North Dakota",
    "South Dakota",
    "Minnesota",
    "Iowa"
  ];

  return (
  <>
    {isSubmitting && (
      <div className="spinner-overlay">
        <div className="spinner"></div>
        <p>Submitting your inquiry...</p>
      </div>
    )}

    <form className="container" onSubmit={handleSubmit}>
      <h2 className="header">
        <img src="/Signaturelogo.png" alt="Rural Grocery Solutions" className="logo" />
      </h2>

      <div className="cardSection">
        <div className="card">
          <div className="form-section">
            <label className="section-label">Current Mason Brother Customer</label>
            <div className="bubble-group">
              <label className={`bubble ${formData.currentCustomer === "Yes" ? "selected" : ""}`}>
                <input
                  type="radio"
                  name="currentCustomer"
                  value="Yes"
                  checked={formData.currentCustomer === "Yes"}
                  onChange={handleChange}
                />
                Yes
              </label>

              <label className={`bubble ${formData.currentCustomer === "Not Yet" ? "selected" : ""}`}>
                <input
                  type="radio"
                  name="currentCustomer"
                  value="Not Yet"
                  checked={formData.currentCustomer === "Not Yet"}
                  onChange={handleChange}
                />
                Not Yet
              </label>
            </div>
          </div>

          <label>Grocery Store Name</label>
          <input type="text" name="storeName" className="input" value={formData.storeName} onChange={handleChange} required />

          <label>Address</label>
          <input type="text" name="storeAddress" className="input" value={formData.storeAddress} onChange={handleChange} required />

          <label>City</label>
          <input type="text" name="storeCity" className="input" value={formData.storeCity} onChange={handleChange} required />

          <label>State</label>
          <select name="storeState" className="select" value={formData.storeState} onChange={handleChange} required>
            <option value="">Select State</option>
            {allowedStates.map(state => (
              <option key={state} value={state}>{state}</option>
            ))}
          </select>

          <label>Zip</label>
          <input type="text" name="storeZip" className="input" value={formData.storeZip} onChange={handleChange} required />

          <label>Phone Number</label>
          <input type="tel" name="storePhone" className="input" value={formData.storePhone} onChange={handleChange} required placeholder="(123) 456-7890" />

          <label>Store Email</label>
          <input type="text" name="storeEmail" className="input" value={formData.storeEmail} onChange={handleChange} />

          <label>Town Population</label>
          <input type="number" name="cityPopulation" className="input" value={formData.cityPopulation} onChange={handleChange} required />

          <label>Contact Name</label>
          <input type="text" name="contactName" className="input" value={formData.contactName} onChange={handleChange} required />

          <label>Contact Phone Number</label>
          <input type="tel" name="contactPhone" className="input" value={formData.contactPhone} onChange={handleChange} required placeholder="(123) 456-7890" />

          <label>Contact Email</label>
          <input type="text" name="contactEmail" className="input" value={formData.contactEmail} onChange={handleChange} />

          <label>Message (optional)</label>
          <textarea name="message" className="input" rows="4" placeholder="Leave a message..." value={formData.message} onChange={handleChange}></textarea>
        </div>
      </div>

      <button type="submit" className="submitButton">Submit</button>
    </form>
  </>
);
}
